export type VoiceBridgeStatus = 'loading' | 'disabled' | 'disconnected' | 'connecting' | 'connected';

export interface VoiceBridgeState {
  ready: boolean;
  enabled: boolean;
  connected: boolean;
  muted: boolean;
  status: VoiceBridgeStatus;
  channel: string;
  inputVolume: number;
  outputVolume: number;
  inputDevice: string;
  outputDevice: string;
  inputDevices: string[];
  outputDevices: string[];
}

export interface VoiceCommandOptions {
  muted?: boolean;
  value?: number;
  deviceName?: string;
}

export const INITIAL_VOICE_STATE: VoiceBridgeState = {
  ready: false,
  enabled: true,
  connected: false,
  muted: true,
  status: 'loading',
  channel: '',
  inputVolume: 1,
  outputVolume: 1,
  inputDevice: '',
  outputDevice: '',
  inputDevices: [],
  outputDevices: [],
};

export function sendVoiceCommand(action: string, options: VoiceCommandOptions = {}): boolean {
  const send = window.sendMessageToUnity;
  if (typeof send !== 'function') return false;

  send(
    'BrowserBridge',
    'ReceivePayload',
    JSON.stringify({
      eventType: 'VoiceCommand',
      payload: JSON.stringify({ action, ...options }),
    })
  );
  return true;
}

export function parseVoiceBridgeState(detail: unknown): VoiceBridgeState | null {
  try {
    const value = typeof detail === 'string' ? JSON.parse(detail) : detail;
    if (!value || typeof value !== 'object') return null;
    const state = value as Partial<VoiceBridgeState>;
    const status = ['loading', 'disabled', 'disconnected', 'connecting', 'connected'].includes(
      String(state.status)
    )
      ? (state.status as VoiceBridgeStatus)
      : state.connected
        ? 'connected'
        : 'disconnected';

    return {
      ...INITIAL_VOICE_STATE,
      ...state,
      status,
      inputDevices: Array.isArray(state.inputDevices) ? state.inputDevices : [],
      outputDevices: Array.isArray(state.outputDevices) ? state.outputDevices : [],
    };
  } catch {
    return null;
  }
}
